import "tippy.js/dist/tippy.css";
import { renderDate } from "../../formatting/dateFormat";
import { renderTitle } from "../../formatting/title";
import {
  BUYBOX_CONDITION_IMAGE,
  BUYBOX_SELLER_IMAGE,
  BUYBOX_SHIP_SPEED_IMAGE,
} from "../../formatting/buyboxInfo";
import { standardizeAndMagnifyEffectHtmlImages } from "../DatatablesEditor/renderers/htmlColumn";
import { trimWithEllipses } from "../DatatablesEditor/renderers/trimWithEllipses";

const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

export const masterInventoryColumnSet = [
  {
    type: "hidden",
    searchable: false,
    data: "inventory_associated_listing_count_view.associated_listing_count",
    name: "inventory_associated_listing_count_view.associated_listing_count",
    className: "no-export",
    render: function (data, type, row) {
      if (Number(data) > 0) {
        return `<div class='details-control'></div>`;
      }
      return null;
    },
  },
  {
    label:
      '<Tooltip title = "User designated sort position" position = "bottom" trigger = "click"><p>Sort</p></Tooltip>',
    name: "supply.sort",
    data: "supply.sort",
    title:
      '<Tooltip title = "User designated sort position" position = "bottom" trigger = "click"><p>Sort</p></Tooltip>',
  },
  {
    label: "UPC",
    name: "supply.upc",
    data: "supply.upc",
    title:
      '<Tooltip title = "UPC(Universal Product Code)/ SKU (Stock Keeping Unit)" position = "bottom" trigger = "click"><p>UPC</p></Tooltip>',
  },
  {
    label: "HTML",
    name: "supply.html",
    data: "supply.html",
    title:
      '<Tooltip title = "General HTML column for row" position = "bottom" trigger = "click"><p>HTML</p></Tooltip>',
    render: standardizeAndMagnifyEffectHtmlImages,
  },
  {
    label: "Title",
    name: "supply.supply_title",
    data: "supply.supply_title",
    title:
      '<Tooltip title = "Yom \'s title for item (not Amazon \'s)" position = "bottom" trigger = "click"><p>Title</p></Tooltip>',
    render: (data, type, row) => renderTitle(data),
  },

  {
    label: "ASIN",
    name: "supply.supply_asin",
    data: "supply.supply_asin",
    title:
      '<Tooltip title = "Supply ASIN (Amazon Standard Identification Number)" position = "bottom" trigger = "click"><p>ASIN</p></Tooltip>',
  },
  {
    label: "Shelf",
    name: "inventory.inventory_shelf",
    data: "inventory.inventory_shelf",
    title:
      '<Tooltip title =  "Where the item can be found in our warehouse " position =  "bottom " trigger =  "click "><p>Shelf</p></Tooltip>',
  },
  {
    name: "supply_families_view.families",
    label:
      '<Tooltip title = "Product families this supply unit is a member of." position = "bottom" trigger = "click"><p>Families</p></Tooltip>',
    attr: {
      disabled: true,
    },
    data: "supply_families_view.families",
    title:
      '<Tooltip title = "Product families this supply unit is a member of." position = "bottom" trigger = "click"><p>Families</p></Tooltip>',
    type: "hidden",

    render: function (data, type, row) {
      return trimWithEllipses(data, 75);
    },
  },
  {
    label:
      '<Tooltip title = "Part number(s) for this inventory unit" position = "bottom" trigger = "click"><p>Part Number</p></Tooltip>',
    name: "inventory.part_number",
    attr: {
      disabled: true,
    },
    type: "hidden",

    data: "inventory.part_number",
    title:
      '<Tooltip title = "Part number(s) for this inventory unit" position = "bottom" trigger = "click"><p>Part Number</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title = "Legacy part number from old system to act as guiding reference with new release" position = "bottom" trigger = "click"><p>Legacy Part Number</p></Tooltip>',
    name: "supply.legacy_part_number",
    attr: {
      disabled: true,
    },
    type: "hidden",

    data: "supply.legacy_part_number",
    title:
      '<Tooltip title = "Legacy part number from old system to act as guiding reference with new release" position = "bottom" trigger = "click"><p>Legacy Part Number</p></Tooltip>',
  },
  {
    name: "inventory.inventory_id",
    data: "inventory.inventory_id",
    type: "hidden",
    visible: false,
  },
  {
    name: "equivalent_upcs_view.equivalent_upcs",
    data: "equivalent_upcs_view.equivalent_upcs",
    type: "hidden",
    visible: false,
  },
  {
    label:
      '<Tooltip title = "Inventory ID for this unit" position = "bottom" trigger = "click"><p>Inventory ID</p></Tooltip>',
    title:
      '<Tooltip title = "Inventory ID for this unit" position = "bottom" trigger = "click"><p>Inventory ID</p></Tooltip>',
    name: "inventory_with_formatted_id_view.formatted_inventory_id",
    data: "inventory_with_formatted_id_view.formatted_inventory_id",
    attr: {
      disabled: true,
    },
    type: "hidden",
  },
  {
    name: "inventory_associated_product_asins_view.product_asins",
    label:
      '<Tooltip title = "Product ASINs this inventory is associated with" position = "bottom" trigger = "click"><p>Product ASINs</p></Tooltip>',
    attr: {
      disabled: true,
    },
    data: "inventory_associated_product_asins_view.product_asins",
    title:
      '<Tooltip title = "Product ASINs this inventory is associated with" position = "bottom" trigger = "click"><p>Product ASINs</p></Tooltip>',
    type: "hidden",

    render: function (data, type, row) {
      return trimWithEllipses(data, 75);
    },
  },
  {
    name: "inventory_active_listing_count_view.active_count",
    label:
      '<Tooltip title = "Count of FBA listings that have sold in the last 90 days" position = "bottom" trigger = "click"><p>Active Listings</p></Tooltip>',
    attr: {
      disabled: true,
    },
    data: "inventory_active_listing_count_view.active_count",
    title:
      '<Tooltip title = "Count of FBA listings that have sold in the last 90 days" position = "bottom" trigger = "click"><p>Active Listings</p></Tooltip>',
    type: "hidden",
  },
  {
    label:
      '<Tooltip title = "Discontinued Date from alliance file" position = "bottom" trigger = "click"><p>Discontinued</p></Tooltip>',
    name: "supply.discontinued_date",
    data: "supply.discontinued_date",
    title:
      '<Tooltip title = "Discontinued Date from alliance file" position = "bottom" trigger = "click"><p>Discontinued</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    name: "media_types[].id",
    label: "Media Types",
    data: "media_types[].id",
    searchable: false,
    orderable: false,
    excludeFromGeneralSearch: true,
    type: "select",
    multiple: true,
    visible: false, // using view column below for display
  },
  {
    name: "supply_media_types_view.media_types",
    title:
      '<Tooltip title = "The media types in this product (Vinyl, Book, CD, DVD, Bluray, 4K)" position = "bottom" trigger = "click"><p>Media Types</p></Tooltip>',
    type: "hidden",
    data: "supply_media_types_view.media_types",
    // using mjoin field above for edit form
  },
  {
    label: "Studio",
    name: "supply.studio",
    data: "supply.studio",
    title:
      '<Tooltip title = "Studio who owns the rights to the title" position = "bottom" trigger = "click"><p>Studio</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label: "Ebay Item ID",
    name: "supply.ebay_itemid",
    data: "supply.ebay_itemid",
    title:
      '<Tooltip title = "Ebay product ID " position = "bottom" trigger = "click"><p>ItemID</p></Tooltip>',
  },
  {
    label: "Walmart SKU",
    name: "supply.walsku",
    data: "supply.walsku",
    title:
      '<Tooltip title = "Walmart SKU" position = "bottom" trigger = "click"><p>WalSKU</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand Short Term Demand Trend Percentage",
    name: "inventory.short_term_demand_trend_percentage",
    data: "inventory.short_term_demand_trend_percentage",
    title:
      '<Tooltip title = "Inventory Demand Short Term Demand Trend Percentage" position = "bottom" trigger = "click"><p>ST Demand %</p></Tooltip>',
    render: function (data, type, row) {
      if (data === undefined || data === null) return null;

      return `${data}%`;
    },
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand Medium Term Demand Trend Percentage",
    name: "inventory.medium_term_demand_trend_percentage",
    data: "inventory.medium_term_demand_trend_percentage",
    title:
      '<Tooltip title = "Inventory Demand Medium Term Demand Trend Percentage" position = "bottom" trigger = "click"><p>MT Demand %</p></Tooltip>',
    render: function (data, type, row) {
      if (data === undefined || data === null) return null;

      return `${data}%`;
    },
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand 7 Day",
    name: "inventory.demand_7d",
    data: "inventory.demand_7d",
    title:
      '<Tooltip title = "Inventory Demand 7 Day" position = "bottom" trigger = "click"><p>Demand 7d</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand 30 Day",
    name: "inventory.demand_30d",
    data: "inventory.demand_30d",
    title:
      '<Tooltip title = "Inventory Demand 30 Day" position = "bottom" trigger = "click"><p>Demand 30d</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand 90 Day",
    name: "inventory.demand_90d",
    data: "inventory.demand_90d",
    title:
      '<Tooltip title = "Inventory Demand 90 Day" position = "bottom" trigger = "click"><p>Demand 90d</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand 365 Day",
    name: "inventory.demand_365d",
    data: "inventory.demand_365d",
    title:
      '<Tooltip title = "Inventory Demand 365 Day" position = "bottom" trigger = "click"><p>Demand 365d</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Demand 365-90-30-7 Day",
    name: "inventory.demand_365d_90d_30d_7d",
    data: "inventory.demand_365d_90d_30d_7d",
    title:
      '<Tooltip title = "Inventory Demand 365-90-30-7 Day" position = "bottom" trigger = "click"><p>Demand All</p></Tooltip>',
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory 30 Day Profit",
    name: "inventory.profit_30d",
    data: "inventory.profit_30d",
    title:
      '<Tooltip title = "Inventory 30 Day Profit" position = "bottom" trigger = "click"><p>30 Day Profit</p></Tooltip>',
    render: function (data, type, row) {
      if (!data) return null;

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(data);
    },
  },
  {
    attr: {
      disabled: true,
    },
    type: "hidden",
    label: "Inventory Purchase Recommendation",
    name: "inventory.inventory_purchase_recommendation",
    data: "inventory.inventory_purchase_recommendation",
    title:
      '<Tooltip title = "Inventory Purchase Recommendation (3 * Demand 30d) - AI Pooled - New Ship Stock)" position = "bottom" trigger = "click"><p>IPR</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title = "The availability of supply inventory needed to fulfill this selling option from our distributors. IS=In stock, BO=Back Order, OP=Out of Print" position = "bottom" trigger = "click"><p>Restock</p></Tooltip>',
    name: "supply.restock_status_ftp",
    attr: {
      disabled: true,
    },
    type: "hidden",
    data: "supply.restock_status_ftp",
    title:
      '<Tooltip title = "The availability of supply inventory needed to fulfill this selling option from our distributors. IS=In stock, BO=Back Order, OP=Out of Print" position = "bottom" trigger = "click"><p>Restock</p></Tooltip>',
    render: function (data, type, row) {
      if (data === "999999") return "Misthreading error.";
      if (data === "OP")
        return `<span style="color:#CC0000;font-weight:700;font-size:17px;">OP</span>`;
      if (data === "BO")
        return `<span style="color:#0066FF;font-weight:700;font-size:17px;">BO</span>`;
      if (data === "IS")
        return `<span style="color:#339933;font-weight:700;font-size:17px;">IS</span>`;

      return null;
    },
  },
  {
    name: "amazon_product_pricing_info.sales_rank",
    label:
      '<Tooltip title =  "Sales rank on Amazon\'s website" position =  "bottom " trigger =  "click "><p>Sales Rank</p></Tooltip>',
    attr: {
      disabled: true,
    },
    type: "hidden",
    data: "amazon_product_pricing_info.sales_rank",
    title:
      '<Tooltip title =  "Sales rank on Amazon\'s website" position =  "bottom " trigger =  "click "><p>Sales Rank</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    name: "amazon_product_pricing_info.product_category",
    label:
      '<Tooltip title =  "" position =  "bottom " trigger =  "click "><p>Product Category</p></Tooltip>',
    attr: {
      disabled: true,
    },
    type: "hidden",
    data: "amazon_product_pricing_info.product_category",
    title:
      '<Tooltip title =  "" position =  "bottom " trigger =  "click "><p>Product Category</p></Tooltip>',
  },
  {
    name: "amazon_product_pricing_info.buy_box_price",
    label:
      '<Tooltip title =  "The price that is currently listed under the buy box" position =  "bottom " trigger =  "click "><p>BuyBox</p></Tooltip>',
    attr: {
      disabled: true,
    },
    type: "hidden",
    data: "amazon_product_pricing_info.buy_box_price",
    title:
      '<Tooltip title =  "The price that is currently listed under the buy box" position =  "bottom " trigger =  "click "><p>BuyBox</p></Tooltip>',
    render: function (data, type, row) {
      if (!data) return null;

      const numericUsd = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(data);

      return numericUsd;
    },
    excludeFromGeneralSearch: true,
  },
  {
    name: "amazon_product_pricing_info.buy_box_info",
    label:
      "<div title='Information about the buybox seller, ship time, and various other listing conditions.'>Buy Box Info</div>",
    attr: {
      disabled: true,
    },
    type: "hidden",

    data: "amazon_product_pricing_info.buy_box_info",
    title: "<div id='buybox-info-container'>Buy Box Info</div>",
    render: function (data, type, row) {
      if (!data) return null;

      const updatedAt = renderDate(row.amazon_product_pricing_info.updated_at);

      data = data.toLowerCase();

      if (!data.includes("-") || data.includes("ineligible")) {
        return `<img src=${BUYBOX_CONDITION_IMAGE[data]} alt='${data}' title='${data}\n\nUpdated: ${updatedAt}' />`;
      }

      if (data.includes("amazon")) {
        let [seller, shipSpeed] = data.split(" - ");

        if (seller === "temp out of stock") {
          [seller, shipSpeed] = [shipSpeed, seller]; // reversing order for TEMP OUT OF STOCK display
          return `<div><img src=${BUYBOX_CONDITION_IMAGE[shipSpeed]} alt='${shipSpeed}' title='${shipSpeed}\n\nUpdated: ${updatedAt}' /><img src=${BUYBOX_SELLER_IMAGE[seller]} alt='${seller}' title='${seller}\n\nUpdated: ${updatedAt}' /></div>`;
        }

        if (shipSpeed)
          return `<div><img src=${BUYBOX_SELLER_IMAGE[seller]} alt='${seller}' title='${seller}\n\nUpdated: ${updatedAt}' /><img src=${BUYBOX_SHIP_SPEED_IMAGE[shipSpeed]} alt='${shipSpeed}' title='${shipSpeed}\n\nUpdated: ${updatedAt}' /></div>`;

        return `<img src=${BUYBOX_SELLER_IMAGE[seller]} alt='${seller}' title='${seller}\n\nUpdated: ${updatedAt}' />`;
      }

      const [status, seller, shipSpeed] = data.split(" - ");

      let statusImg = BUYBOX_CONDITION_IMAGE[status];
      let shipSpeedImg = BUYBOX_SHIP_SPEED_IMAGE[shipSpeed];

      if (seller === "not yom") {
        if (shipSpeed)
          return `<div><img src=${statusImg} alt='${status}' title='${status} - not yom\n\nUpdated: ${updatedAt}' /><img src=${shipSpeedImg} alt='${shipSpeed}' title='${shipSpeed}\n\nUpdated: ${updatedAt}' /></div>`;

        return `<img src=${statusImg} alt='${status}' title='${status} - not yom\n\nUpdated: ${updatedAt}' />`;
      }

      let sellerImg = BUYBOX_SELLER_IMAGE[seller];

      if (shipSpeed)
        return `<div><img src=${statusImg} alt='${status}' title='${status}\n\nUpdated: ${updatedAt}' /><img src=${sellerImg} alt='${seller}' title='${seller}\n\nUpdated: ${updatedAt}' /><img src=${shipSpeedImg} alt='${shipSpeed}' title='${shipSpeed}\n\nUpdated: ${updatedAt}' /></div>`;

      return `<div><img src=${statusImg} alt='${status}' title='${status}\n\nUpdated: ${updatedAt}' /><img src=${sellerImg} alt='${seller}' title='${seller}\n\nUpdated: ${updatedAt}' /></div>`;
    },
  },
  {
    name: "amazon_product_pricing_info.updated_at",
    data: "amazon_product_pricing_info.updated_at",
    visible: false,
    type: "hidden",
  },
  {
    label: "Supplier Link",
    name: "supply.sup_lin",
    data: "supply.sup_lin",
    title:
      '<Tooltip title = "Supplier hot links to selected products, or to suppliers not currently being scraped" position = "bottom" trigger = "click"><p>Sup Link</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title = "Listing department queue, and work orders" position = "bottom" trigger = "click"><p>Listed</p></Tooltip>',
    name: "supply.listed",
    data: "supply.listed",
    title:
      '<Tooltip title = "Listing department queue, and work orders" position = "bottom" trigger = "click"><p>Listed</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title =  "ONO (On Order) Inventory that has been ordered through supplier, and has not yet been delivered to our warehouse" position =  "bottom " trigger =  "click "><p>ONO</p></Tooltip>',
    name: "supply.ono",
    data: "supply.ono",
    attr: {
      disabled: true,
    },
    type: "hidden",
    title:
      '<Tooltip title =  "ONO (On Order) Inventory that has been ordered through supplier, and has not yet been delivered to our warehouse" position =  "bottom " trigger =  "click "><p>ONO</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Pooled ONO (On Order) Inventory that has been ordered through supplier, and has not yet been delivered to our warehouse" position =  "bottom " trigger =  "click "><p>ONO Pooled</p></Tooltip>',
    name: "inventory.ono_pooled",
    data: "inventory.ono_pooled",
    attr: {
      disabled: true,
    },
    type: "hidden",
    title:
      '<Tooltip title =  "Pooled ONO (On Order) Inventory that has been ordered through supplier, and has not yet been delivered to our warehouse" position =  "bottom " trigger =  "click "><p>ONO Pooled</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "The average (mean) cost paid for the product in our warehouse." position =  "bottom " trigger =  "click "><p>AVCG</p></Tooltip>',
    name: "inventory.avcg",
    data: "inventory.avcg",
    type: "hidden",
    title:
      '<Tooltip title =  "The average (mean) cost paid for the product in our warehouse." position =  "bottom " trigger =  "click "><p>AVCG</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "The lowest price paid for this unit in the last year" position =  "bottom " trigger =  "click "><p>One Year Lowest COGS</p></Tooltip>',
    name: "inventory.one_year_lowest_cost",
    data: "inventory.one_year_lowest_cost",
    type: "hidden",
    title:
      '<Tooltip title =  "The lowest price paid for this unit in the last year" position =  "bottom " trigger =  "click "><p>One Year Lowest COGS</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Inv  + ONO Pooled" position =  "bottom " trigger =  "click "><p>AI Pooled</p></Tooltip>',
    name: "inventory.ai_pooled",
    data: "inventory.ai_pooled",
    type: "hidden",
    title:
      '<Tooltip title =  "Inv  + ONO Pooled" position =  "bottom " trigger =  "click "><p>AI Pooled</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Analyst/Purchaser work order " position =  "bottom " trigger =  "click "><p>House</p></Tooltip>',
    name: "supply.house",
    data: "supply.house",
    title:
      '<Tooltip title =  "Analyst/Purchaser work order " position =  "bottom " trigger =  "click "><p>House</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title =  "Analyst/Purchaser work order " position =  "bottom " trigger =  "click "><p>House 2</p></Tooltip>',
    name: "supply.house_2",
    data: "supply.house_2",
    title:
      '<Tooltip title =  "Analyst/Purchaser work order " position =  "bottom " trigger =  "click "><p>House 2</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title =  "General note column for supply / inventory rows " position =  "bottom " trigger =  "click "><p>Notes</p></Tooltip>',
    name: "supply.supply_notes",
    data: "supply.supply_notes",
    title:
      '<Tooltip title =  "General note column for supply / inventory rows " position =  "bottom " trigger =  "click "><p>Notes</p></Tooltip>',
    render: function (data, type, row) {
      return trimWithEllipses(data, 75);
    },
  },
  {
    label:
      '<Tooltip title =  "Threading Notes " position =  "bottom " trigger =  "click "><p>Threading Notes</p></Tooltip>',
    name: "supply.threading_notes",
    data: "supply.threading_notes",
    title:
      '<Tooltip title =  "Threading Notes " position =  "bottom " trigger =  "click "><p>Threading Notes</p></Tooltip>',
    render: function (data, type, row) {
      return trimWithEllipses(data, 75);
    },
  },
  {
    label:
      '<Tooltip title =  "Inventory Notes " position =  "bottom " trigger =  "click "><p>Inventory Notes</p></Tooltip>',
    name: "supply.inventory_notes",
    data: "supply.inventory_notes",
    title:
      '<Tooltip title =  "Inventory Notes " position =  "bottom " trigger =  "click "><p>Inventory Notes</p></Tooltip>',
    render: function (data, type, row) {
      return trimWithEllipses(data, 75);
    },
  },
  {
    label:
      '<Tooltip title =  "When the product was last scanned into inventory " position =  "bottom " trigger =  "click "><p>Add Date</p></Tooltip>',
    name: "inventory.add_date",
    data: "inventory.add_date",
    type: "hidden",
    title:
      '<Tooltip title =  "When the product was last scanned into inventory " position =  "bottom " trigger =  "click "><p>Add Date</p></Tooltip>',
    render: renderDate,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "When the product was last scanned out of inventory " position =  "bottom " trigger =  "click "><p>Sub Date</p></Tooltip>',
    name: "inventory.sub_date",
    data: "inventory.sub_date",
    type: "hidden",
    title:
      '<Tooltip title =  "When the product was last scanned out of inventory " position =  "bottom " trigger =  "click "><p>Sub Date</p></Tooltip>',
    render: renderDate,
    excludeFromGeneralSearch: true,
  },
  {
    name: "supply.inventory_id",
    data: "supply.inventory_id",
    type: "hidden",
    visible: false,
    excludeFromGeneralSearch: true,
  },

  {
    label:
      '<Tooltip title =  "How much of this item is in our East Aurora warehouse " position =  "bottom " trigger =  "click "><p>Inv</p></Tooltip>',
    name: "inventory.inv",
    data: "inventory.inv",
    attr: {
      disabled: true,
    },
    type: "hidden",
    title:
      '<Tooltip title =  "How much of this item is in our East Aurora warehouse " position =  "bottom " trigger =  "click "><p>Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Alliance Entertainment Distributor inventory " position =  "bottom " trigger =  "click "><p>Dist Inv</p></Tooltip>',
    name: "supply.dist_inv",
    data: "supply.dist_inv",
    type: "hidden",
    title:
      '<Tooltip title =  "Alliance Entertainment Distributor inventory " position =  "bottom " trigger =  "click "><p>Dist Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Dealsareus Distributor inventory (DIsplayed as #currently on hand - #currently available from their supplier) " position =  "bottom " trigger =  "click "><p>DAU Inv</p></Tooltip>',
    name: "supply.dau_inv",
    data: "supply.dau_inv",
    type: "hidden",
    title:
      '<Tooltip title =  "Dealsareus Distributor inventory (DIsplayed as #currently on hand - #currently available from their supplier) " position =  "bottom " trigger =  "click "><p>DAU Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },

  {
    label:
      '<Tooltip title =  "Mila inventory available" position =  "bottom " trigger =  "click "><p>Mila Inv</p></Tooltip>',
    name: "supply.mila_inv",
    data: "supply.mila_inv",
    type: "hidden",
    title:
      '<Tooltip title =  "Mila inventory available" position =  "bottom " trigger =  "click "><p>Mila Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Mila inv\n\nUpdated at: ${row["supply"]["mila_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title =  "Discount Entertainment inventory available" position =  "bottom " trigger =  "click "><p>DE Inv</p></Tooltip>',
    name: "supply.discount_entertainment_inv",
    data: "supply.discount_entertainment_inv",
    title:
      '<Tooltip title =  "Discount Entertainment inventory available" position =  "bottom " trigger =  "click "><p>DE Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
    type: "hidden",
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Discount Entertainment inv\n\nUpdated at: ${row["supply"]["discount_entertainment_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Gruv supplier inventory available" position =  "bottom " trigger =  "click "><p>Gruv Inv</p></Tooltip>',
    name: "supply.gruv_inv",
    data: "supply.gruv_inv",
    type: "hidden",
    title:
      '<Tooltip title = "Gruv supplier inventory available" position =  "bottom " trigger =  "click "><p>Gruv Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Gruv inv\n\nUpdated at: ${row["supply"]["gruv_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title =  "Wildcard 1 supplier inventory available" position =  "bottom " trigger =  "click "><p>WC1 Inv</p></Tooltip>',
    name: "supply.wildcard1_inv",
    data: "supply.wildcard1_inv",
    type: "hidden",
    title:
      '<Tooltip title =  "Wildcard 1 supplier inventory available" position =  "bottom " trigger =  "click "><p>WC1 Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Wildcard1 inv\n\nUpdated at: ${row["supply"]["wildcard1_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title =  "Wildcard 2 supplier inventory available" position =  "bottom " trigger =  "click "><p>WC2 Inv</p></Tooltip>',
    name: "supply.wildcard2_inv",
    data: "supply.wildcard2_inv",
    type: "hidden",
    title:
      '<Tooltip title =  "Wildcard 2 supplier inventory available" position =  "bottom " trigger =  "click "><p>WC2 Inv</p></Tooltip>',
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Wildcard2 inv\n\nUpdated at: ${row["supply"]["wildcard2_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title =  "The quantity of damage products in order of damage reason 1-2-3." position =  "bottom " trigger =  "click "><p>DMG Inv</p></Tooltip>',
    name: "supply.dmg_inv_display",
    data: "supply.dmg_inv_display",
    type: "hidden",
    title:
      '<Tooltip title =  "The quantity of damage products in order of damage reason 1-2-3." position =  "bottom " trigger =  "click "><p>DMG Inv</p></Tooltip>',
    attr: {
      disabled: true,
    },
    excludeFromGeneralSearch: true,
  },
  {
    label: "Product List Type",
    name: "supply.prod_list_type",
    data: "supply.prod_list_type",
    title:
      '<Tooltip title =  "Product List Type" position =  "bottom " trigger =  "click "><p>Product List Type</p></Tooltip>',
  },
  {
    label:
      '<Tooltip title = "Keepa 30 day Buybox Avg" position = "bottom" trigger = "click"><p>Keepa 30d</p></Tooltip>',
    name: "keepa_product_data.keepa_buybox_30_day_avg",
    data: "keepa_product_data.keepa_buybox_30_day_avg",
    title:
      '<Tooltip title = "Keepa 30 day buybox average" position = "bottom" trigger = "click"><p>Keepa 30d</p></Tooltip>',
    excludeFromGeneralSearch: true,
    render: (data) => {
      const formatCurrency = (data) =>
        data ? `$${Number(data).toFixed(2)}` : "";
      return formatCurrency(data);
    },
  },
  {
    label:
      '<Tooltip title = "When was the data pulled from Keepa API" position = "bottom" trigger = "click"><p>Keepa TimeStamp</p></Tooltip>',
    name: "keepa_product_data.keepa_timestamp",
    data: "keepa_product_data.keepa_timestamp",
    type: "hidden",
    title:
      '<Tooltip title = "When was the data pulled from Keepa API" position = "bottom" trigger = "click"><p>Keepa TimeStamp</p></Tooltip>',
    render: renderDate,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Analytic DB column 1" position =  "bottom " trigger =  "click "><p>Analytics DB 1</p></Tooltip>',
    name: "supply.analytics_db_column_1",
    data: "supply.analytics_db_column_1",
    type: "hidden",
    title:
      '<Tooltip title =  "Analytic DB column 1" position =  "bottom " trigger =  "click "><p>Analytics DB 1</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title =  "Analytic DB column 2" position =  "bottom " trigger =  "click "><p>Analytics DB 2</p></Tooltip>',
    name: "supply.analytics_db_column_2",
    data: "supply.analytics_db_column_2",
    type: "hidden",
    title:
      '<Tooltip title =  "Analytic DB column 2" position =  "bottom " trigger =  "click "><p>Analytics DB 2</p></Tooltip>',
    excludeFromGeneralSearch: true,
  },
  {
    columnDependencies: ["supply.dtb1_supplier"],
    label:
      '<Tooltip title = "DTB (Direct to Buyer) Terminal or Landed Cost of a product (includes any volume discounts, promotions and rebates)" position = "bottom" trigger = "click"><p>DTB1</p></Tooltip>',
    name: "supply.dtb1",
    className: ".dtb",
    data: "supply.dtb1",
    type: "hidden",
    title:
      '<Tooltip title = "DTB (Direct to Buyer) Terminal or Landed Cost of a product (includes any volume discounts, promotions and rebates)" position = "bottom" trigger = "click"><p>DTB1</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb1_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data} `;
    },
  },
  {
    columnDependencies: ["supply.dtb2_supplier"],
    label:
      '<Tooltip title = "DTB2 (Supplier with the 2nd lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB2</p></Tooltip>',
    name: "supply.dtb2",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb2",
    title:
      '<Tooltip title = "DTB2 (Supplier with the 2nd lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB2</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb2_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
  },
  {
    columnDependencies: ["supply.dtb3_supplier"],
    label:
      '<Tooltip title = "DTB3 (Supplier with the 3rd lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB3</p></Tooltip>',
    name: "supply.dtb3",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb3",
    title:
      '<Tooltip title = "DTB3 (Supplier with the 3rd lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB3</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb3_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
  },
  {
    columnDependencies: ["supply.dtb4_supplier"],
    label:
      '<Tooltip title = "DTB4 (Supplier with the 4th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB4</p></Tooltip>',
    name: "supply.dtb4",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb4",
    title:
      '<Tooltip title = "DTB4 (Supplier with the 4th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB4</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb4_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
    excludeFromGeneralSearch: true,
  },
  {
    columnDependencies: ["supply.dtb5_supplier"],
    label:
      '<Tooltip title = "DTB5 (Supplier with the 5th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB5</p></Tooltip>',
    name: "supply.dtb5",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb5",
    title:
      '<Tooltip title = "DTB5 (Supplier with the 5th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB5</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb5_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
    excludeFromGeneralSearch: true,
  },
  {
    columnDependencies: ["supply.dtb6_supplier"],
    label:
      '<Tooltip title = "DTB6 (Supplier with the 6th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB6</p></Tooltip>',
    name: "supply.dtb6",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb6",
    title:
      '<Tooltip title = "DTB6 (Supplier with the 6th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB6</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb6_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
    excludeFromGeneralSearch: true,
  },
  {
    columnDependencies: ["supply.dtb7_supplier"],
    label:
      '<Tooltip title = "DTB7 (Supplier with the 7th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB7</p></Tooltip>',
    name: "supply.dtb7",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb7",
    title:
      '<Tooltip title = "DTB7 (Supplier with the 7th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB7</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb7_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
    excludeFromGeneralSearch: true,
  },
  {
    columnDependencies: ["supply.dtb8_supplier"],
    label:
      '<Tooltip title = "DTB8 (Supplier with the 8th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB8</p></Tooltip>',
    name: "supply.dtb8",
    className: ".dtb",
    type: "hidden",
    data: "supply.dtb8",
    title:
      '<Tooltip title = "DTB8 (Supplier with the 8th lowest terminal price - see also DTB1)" position = "bottom" trigger = "click"><p>DTB8</p></Tooltip>',
    render: (data, type, row) => {
      if (!data) return "";

      const supplierName = row.supply.dtb8_supplier;
      return `<img title=${supplierName} height="16px" width="16px" src=${cloudfrontUrl}${supplierName}.png /> ${data}`;
    },
    excludeFromGeneralSearch: true,
  },

  {
    label:
      '<Tooltip title = "Alliance Entertainment price" position = "bottom" trigger = "click"><p>Alliance</p></Tooltip>',
    name: "supply.alliance",
    className: ".st",
    data: "supply.alliance",
    title: `<img class='small-icon' title = "Alliance Entertainment price" src=${require("../../../assets/icons/alliance.png")} alt="Alliance" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Amazon supplier scraped price" position = "bottom" trigger = "click"><p>Amazon</p></Tooltip>',
    name: "supply.amazon",
    className: ".st",
    data: "supply.amazon",
    title: `<img class='small-icon' title = "Amazon price" src=${require("../../../assets/icons/amazon.png")} alt="Amazon" />`,

    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "CC Video supplier scraped price" position = "bottom" trigger = "click"><p>CCVideo</p></Tooltip>',
    name: "supply.ccvideo",
    className: ".st",
    data: "supply.ccvideo",
    title: `<img class='small-icon' title = "CCVideo price" src=${require("../../../assets/icons/ccvideo.png")} alt="CCVideo" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Deals Distributor Price" position = "bottom" trigger = "click"><p>Dealsareus</p></Tooltip>',
    name: "supply.dealsareus",
    className: ".st",
    data: "supply.dealsareus",
    title: `<img class='small-icon' title = "Deals R Us price" src=${require("../../../assets/icons/dealsareus.png")} alt="Deals R Us" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Deep Discount supplier scraped price" position = "bottom" trigger = "click"><p>DeepDiscount</p></Tooltip>',
    name: "supply.deepdiscount",
    className: ".st",
    data: "supply.deepdiscount",
    title: `<img class='small-icon' title = "Deep Discount price" src=${require("../../../assets/icons/deepdiscount.png")} alt="Deepdiscount" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Discount Entertainment supplier scraped price" position = "bottom" trigger = "click"><p>Discount Entertainment</p></Tooltip>',
    name: "supply.discount_entertainment",
    className: ".st",
    data: "supply.discount_entertainment",
    title: `<img class='small-icon' title = "Discount Entertainment price" src=${require("../../../assets/icons/discount_entertainment.png")} alt="Discount Entertainment" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Discount Entertainment price\n\nUpdated at: ${row["supply"]["discount_entertainment_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Ebay BlowItOutofHere (Ebay Supplier) scraped price" position = "bottom" trigger = "click"><p>EbayBlowIt</p></Tooltip>',
    name: "supply.blowitebay",
    className: ".st",
    data: "supply.blowitebay",
    title: `<img class='small-icon' title = "Ebay Blowitoutahere price" src=${require("../../../assets/icons/ebayblowit.png")} alt="Ebay Blowit" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "InetVideo Music scraped price (Website / Supplier has ceased operations)" position = "bottom" trigger = "click"><p>HeartLand</p></Tooltip>',
    name: "supply.inetvideo",
    className: ".st",
    data: "supply.inetvideo",
    title: `<img class='small-icon' title = "InetVideo price" src=${require("../../../assets/icons/inetvideo.png")} alt="InetVideo" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Import CDs supplier scraped price" position = "bottom" trigger = "click"><p>ImportCDs</p></Tooltip>',
    name: "supply.importcds",
    className: ".st",
    data: "supply.importcds",
    title: `<img class='small-icon' title = "ImportCDs price" src=${require("../../../assets/icons/importcds.png")} alt="ImportCDs" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Mila supplier scraped price " position = "bottom" trigger = "click"><p>Mila</p></Tooltip>',
    name: "supply.mila",
    className: ".st",
    data: "supply.mila",
    title: `<img class='small-icon' title = "Mila price" src=${require("../../../assets/icons/mila.png")} alt="Mila" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Mila price\n\nUpdated at: ${row["supply"]["mila_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Gruv supplier scraped price (Website / Supplier has ceased operations)" position = "bottom" trigger = "click"><p>Gruv</p></Tooltip>',
    name: "supply.gruv",
    className: ".st",
    data: "supply.gruv",
    title: `<img class='small-icon' title = "Gruv price" src=${require("../../../assets/icons/gruv.png")} alt="Gruv" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Gruv price\n\nUpdated at: ${row["supply"]["gruv_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Wildcard1 product price" position = "bottom" trigger = "click"><p>Wildcard1</p></Tooltip>',
    name: "supply.wildcard1",
    className: ".st",
    data: "supply.wildcard1",
    title: `<img class='small-icon' title = "Wildcard 1 Price" src=${require("../../../assets/icons/wildcard1.png")} alt="WC1 Price" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Wildcard1 price\n\nUpdated at: ${row["supply"]["wildcard1_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Wildcard2 product price" position = "bottom" trigger = "click"><p>Wildcard2</p></Tooltip>',
    name: "supply.wildcard2",
    className: ".st",
    data: "supply.wildcard2",
    title: `<img class='small-icon' title = "Wildcard 2 Price" src=${require("../../../assets/icons/wildcard2.png")} alt="WC2 Price" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Wildcard2 price\n\nUpdated at: ${row["supply"]["wildcard2_data_timestamp"]}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "Rarewaves supplier scraped price" position = "bottom" trigger = "click"><p>Rarewaves</p></Tooltip>',
    name: "supply.rarewaves",
    className: ".st",
    data: "supply.rarewaves",
    title: `<img class='small-icon' title = "Rarewaves price" src=${require("../../../assets/icons/rarewaves.png")} alt="Rarewaves" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "Target supplier scraped price (Website / Supplier has ceased operations)" position = "bottom" trigger = "click"><p>Target</p></Tooltip>',
    name: "supply.target_store",
    className: ".st",
    data: "supply.target_store",
    title: `<img class='small-icon' title = "Target price" src=${require("../../../assets/icons/target.png")} alt="Target" />`,
    excludeFromGeneralSearch: true,
  },
  {
    label:
      '<Tooltip title = "VEI scraped price  (Website / Supplier has ceased operations)" position = "bottom" trigger = "click"><p>VEI</p></Tooltip>',
    name: "supply.vei",
    className: ".st",
    data: "supply.vei",
    title: `<img class='small-icon' title = "VEI price" src=${require("../../../assets/icons/vei.png")} alt="VEI" />`,
    excludeFromGeneralSearch: true,
  },

  {
    label:
      '<Tooltip title = "Walmart Supplier Scraped Price" position = "bottom" trigger = "click"><p>Walmart</p></Tooltip>',
    name: "supply.walmart",
    className: ".st",
    data: "supply.walmart",
    title: `<img class='small-icon' title = "Walmart price" src=${require("../../../assets/icons/walmart.png")} alt="Walmart" />`,
    excludeFromGeneralSearch: true,
    render: (data, type, row) => {
      if (!data) return "";

      return `<span title='Walmart price\n\nUpdated at: ${renderDate(
        row["supply"]["walmart_updated_timestamp"]
      )}'>${data}</span>`;
    },
  },
  {
    label:
      '<Tooltip title = "WowHD Supplier Scraped Price" position = "bottom" trigger = "click"><p>WOWHD</p></Tooltip>',
    name: "supply.wowhd",
    className: ".st",
    data: "supply.wowhd",
    title: `<img class='small-icon' title = "WowHD price" src=${require("../../../assets/icons/wowhd.png")} alt="WowHD" />`,

    excludeFromGeneralSearch: true,
  },
  {
    type: "hidden",
    label:
      '<Tooltip title = "When this supply row was created in YOM\'s system" position = "bottom" trigger = "click"><p>Created At</p></Tooltip>',
    name: "supply.created_at",
    data: "supply.created_at",
    title:
      '<Tooltip title = "When this supply row was created in YOM\'s system" position = "bottom" trigger = "click"><p>Created At</p></Tooltip>',
    render: renderDate,
    excludeFromGeneralSearch: true,
  },
];

/**
 * Returns array of all columns for a given column set.
 * Will use the masterInventoryColumnSet if no column names are given.
 * @param {array} columnNames Optional
 * @returns {array}
 */
export function getColumnSet(columnNames) {
  if (!columnNames) return masterInventoryColumnSet;

  const columns = [];

  columnNames.forEach((col) => {
    const column = masterInventoryColumnSet.find(
      (colDefinition) => colDefinition.data === col
    );
    if (column) columns.push(column);
  });

  const columnsToHide = masterInventoryColumnSet
    .map((col) => col.name)
    .filter((name) => !columnNames.includes(name));

  // adding rest of columns from master set as hidden - edits will be broken otherwise
  const nonViewableColumns = masterInventoryColumnSet
    .filter((col) => columnsToHide.includes(col.data))
    .map((col) => ({ ...col, visible: false, type: "hidden" }));

  return [...columns, ...nonViewableColumns];
}

/**
 * Returns array of only *viewable* columns for a given column set.
 * Will use the masterInventoryColumnSet if no column names are given.
 * @param {array} columnNames Optional
 * @returns {array}
 */
export function getViewableInventoryColumns(columnNames) {
  let columnSet = [];
  if (!columnNames) {
    columnSet = masterInventoryColumnSet.map((c) => c);
  } else {
    columnSet = getColumnSet([
      "inventory_associated_listing_count_view.associated_listing_count",
      ...columnNames,
    ]);
  }

  // Adding column dependencies
  columnSet
    .map((c) => c)
    .forEach((col) => {
      if (col.columnDependencies) {
        col.columnDependencies.forEach((name) => {
          if (!columnSet.find((c) => c.data === name))
            columnSet.push({
              data: name,

              visible: false,
            });
        });
      }
    });

  return columnSet;
}

export const nestedTableColumns = [
  "product.sort",
  "product.msku",
  "product.product_asin",
  "product.status",
  "product_families_view.families",
  "product.html",
  "product.assembly_part_number",
  "product.product_title",
  "product_listings.total_sales",
  "product.page_sales_365_90_30_7",
  "product_listings.last_non_cancelled_order_timestamp",
  "product.buy_box_markup_display",
  "amazon_product_pricing_info.buy_box_info",
  "amazon_product_pricing_info.buy_box_price",
  "product_listings.price",
  "product.an",
  "product.yom_purchase_rec",
  "product.master_analyst_inv",
  "product.ats",
  "product.ats_last_increase_timestamp",
  "product_listings.30_day_profit",
  "product.ship_stock",
  "product.stock",
  "product.yom_ship_rec_holiday",
  "product.yom_ship_rec",
  "product.amz_recommended_ship_quantity",
  "product.yom_ship_rec_amz_ship_rec_diff",
  "product.30_day_restock_in_stock_count",
  "product.restock_status_calculated",
  "product_listings.merchant_available",
  "product_listings.purchasable_stock",
  "product.master_avg_cost_of_goods",
  "product.master_avg_cogs_ninety_day",
  "product.7_day_sales",
  "product.one_year_lowest_cost",
  "product.replacement_cost",
  "product.replacement_cost_dist",
  "product.cogs",
  "product.ysr_nss_rec",
  "product.analytics_db_column_1",
  "product.analytics_db_column_2",
  "product.analytics_db_column_3",
  "product.analytics_db_column_4",
  "product.profit",
  "product.margin",
  "product.margin_30_pricing",
  "product.margin_15_pricing",
  "product.margin_0_pricing",
  "product.cogs_update_timestamp",
  "product.next_amz_ship_qty",
  "product.amz_ship_qty",
  "product.amz_queue",
  "product.pick_status",
  "product.fba_sell_through",
  "product.alert",
  "product_media_types_view.media_types",
  "product.component_count",
  "product.yom_handling_cost_adjustment",
  "product.packaged_weight_ounces",
  "product.yom_handling_cost_adjustment",
  "product.orders",
  "product.shelf",
  "product.wn",
  "product.wwo",
  "product.proceeds",
  "product_listings.open_date",
  "product.retired",
  "product.retired_timestamp",
  "product.weeks_until_depleted",
  "product.amazon_stock_weeks_until_depleted",
  "product.master_quantity_on_order",
  "product.roi",
  "product.last_ninety_day_avg_cogs",
  "product.latest_timestamp",
  "product.30_day_sales",
  "product.type",
  "product.genre",
  "product.card_number",
  "product.ship_weight",
  "product.fnsku",
  "product.part_number",
  "product.listory",
  "product.prod_list_type",
  "product.inv_age_271_to_365",
  "product_profit_projection_view.yom_ship_rec_potential_profit",
  "product.fba_latest_shipment_quantity",
  "product.90_day_sales",
  "amazon_product_pricing_info.sales_rank",
];
